export default __webpack_public_path__ + "static/media/in.4623abf1.svg";